<p8-settings-page>
  <p8-settings-header [titlePath]="['Pages', 'Nouvelle page']"></p8-settings-header>

  <p8-bdc-page-form></p8-bdc-page-form>

  <p8-settings-footer>
    <button mat-raised-button
            color="accent"
            [disabled]="pageFormComponent.pageForm.pristine || !pageFormComponent.pageForm.valid"
            (click)="onSubmit()"
    >CRÉER PAGE</button>
    <button mat-button (click)="onCancel()">ANNULER</button>
  </p8-settings-footer>
</p8-settings-page>
